import React from 'react'
import _ from 'lodash'
import { BorderOutlined } from '@ant-design/icons'
import { Avatar, Menu } from 'antd'
import { app, use, config } from 'xadmin'
import { Icon } from 'xadmin-ui';
import { onAuthorization } from '../components/util'
const { SubMenu } = Menu;

const authMenudata = (menuItems, permissions) => {
  if (permissions && menuItems) {
    return menuItems.filter(item => (!item?.permission || _.includes(permissions, item?.permission)))
  }
  return menuItems
}

const antdVersion = window?.antd?.version || ''

const useMenuItems = (data, canClick = true, user, name) => {
  let v3 = false
  let menuItems = data
  // 判断dll的antd 版本显示不同的菜单
  if (name == 'MainMenu' && antdVersion.startsWith('4.2')) {
    v3 = true
    menuItems = [
      { title: '物联管理', key: 'scada', icon: 'Cmdb', },
      { title: '业务管理', key: 'business', icon: 'Node', },
      { title: '数据分析', key: 'analyse', icon: 'Analysis', },
      { title: '二次开发', key: 'develop', icon: 'Event', },
      ...data,
    ]
  }

  // 根据角色权限控制菜单是否显示
  menuItems = user?.isSuper ? menuItems : authMenudata(menuItems, user?.permissions)

  const onMenuClick = e => {
    const url = _.isString(e) ? e : e.item?.props?.url
    if (url && canClick) {
      if (url.indexOf('http') >= 0) {
        window.open(url)
      } else {
        app.go(url)
      }
    }
  }

  const items = React.useMemo(() => {
    const menus = menuItems.reduce((p, m) => {
      const pk = v3 ? (m.parent || '') : ''
      return { ...p, [pk]: [...(p[pk] || []), m] }
    }, {})

    const convertItem = item => {
      let icon = item.icon || <BorderOutlined className="menu-none-icon" />
      if (icon && _.isString(icon)) {
        if (icon.indexOf('/') > -1) {
          icon = <Avatar className="nav-icon" shape="square" src={config('mediaUrl') + icon} />
        } else {
          const icons = app.get('icons')
          const svgIcon = _.find(icons, item => item.name == icon)
          if (svgIcon) {
            icon = <Icon className="nav-icon" svg={svgIcon.url} />
          }
        }
      }

      return {
        ...item,
        key: item.key || item.title,
        label: item.label || item.title,
        icon
      }
    }

    const find_childs = (key) => {
      return (menus[key] || []).map((r) => {
        const childs = find_childs(r.key || r.title)
        if (!_.isEmpty(childs) || !_.isEmpty(r.children)) {
          r = {
            ...r, children: [
              ...(r.children || []).map(convertItem),
              ...childs
            ]
          }
        }
        return convertItem(r)
      }).filter(Boolean)
    }
    // 过滤不存在子菜单或者没有url的
    return find_childs('').filter(m => (m.children || m.url))

  }, [menuItems])



  const renderMenu = (menuTreeData, mode) => {
    if (!menuTreeData || _.isEmpty(menuTreeData)) return
    if (!user?.isAdmin) { menuTreeData = menuTreeData.filter(item => item.title != '催款模块') }
    return menuTreeData.map(item => {
      if (item.title == '系统设置') return
      let titileIcon = <Avatar className="nav-icon" shape="square" />
      if (item.icon) {
        titileIcon = item.icon
      }
      if (!onAuthorization(item.permission)) {
        return null
      }
      if (item.children && item.children.length > 0 && item.url != '/app/model/Dashboard/list') {
        const title = item.ellipsis ? (
          <a className="submenu-title-wrapper">
            <Icon type="ellipsis" style={{ fontSize: 24, color: 'rgba(255, 255, 255, 0.65)', marginLeft: -3 }} />
          </a>
        ) : (
          <a className="submenu-title-wrapper" onClick={() => item.url && onMenuClick(item.url)}>
            {titileIcon}
            <span className="nav-text" >{item.title}</span>
          </a>
        )
        return (
          <SubMenu
            className={mode == 'horizontal' ? 'submenu-reset' : 'submenu-inline'}
            title={title}
            key={item.url}
          >
            {renderMenu(item.children, mode)}
          </SubMenu>
        )
      }

      return (
        <Menu.Item key={item.url} title={item.title}>
          <a onClick={() => item.onClick ? item.onClick() : item.url && onMenuClick(item.url)}>
            {titileIcon}
            <span className="nav-text" >{item.title}</span>
          </a>
        </Menu.Item>
      )
    })
  }

  return { items, onMenuClick, renderMenu }
}

export {
  useMenuItems
}